import React from 'react';

import BaseSvg from '../../BaseSvg';
import { InjectedSvgProps } from '../../hocs';

export default class AdvantageSvg extends React.PureComponent<InjectedSvgProps> {
    render() {
        const { fillColor, secondaryFillColor, className } = this.props;

        let classNames: Array<string> = ['ddbc-advantage-svg'];

        if (className) {
            classNames.push(className);
        }

        return (
            <BaseSvg className={classNames.join(' ')} viewBox="0 0 48 48">
                <g>
                    <polygon fill={secondaryFillColor} points="33 6 38 36 10 36 16 6"></polygon>
                    <polygon fill={fillColor} points="24 14 28 26 20 26 24 14"></polygon>
                    <path
                        fill={fillColor}
                        d="M44.39,12.1,23.89.39,3.5,12.29,3.61,35.9l20.5,11.71L44.5,35.71ZM31,36l-2-6H19l-2,6H10L21,8h6L38,36Z"
                    ></path>
                </g>
            </BaseSvg>
        );
    }
}
